/*eslint-disable*/
import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    MainHeadline,
    PageWrapper,
    PageFooter,
    Separator,
    Th,
    SectionButton,
    Box,
    ColoredDot,
    TabsContainer,
    Tabs,
} from '../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import { ModalTypes } from '../../types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { useNavigate } from 'react-router-dom'
import { clearAccommodations, deleteAccommodation, getAccommodations } from 'features/accommodation/accommodationSlice'
import { accommodationCategories, accommodationTypes } from './accommodationData'
import { BodyText, TitleText } from 'styling/Typography'
import { AccomodationDashboard } from './Sections/AccommodationDashboard'
import { BedManagement } from './Sections/BedManagement'
import { CheckIn } from './Sections/CheckIn'
import { CheckOut } from './Sections/CheckOut'
import { Guests } from './Sections/Guests'
import { BedHistory } from './Sections/BedHistory'
import { AddAccommodationModal } from './Sections/AddAccommodationModal'

export const Accommodation: React.FC = () => {
    const { accommodations, totalPages } = useSelector((store: RootState) => store.accomodation)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [active, setActive] = useState('Dashboard')
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const [modal, setModal] = useState(false)
    // useQueryPagination({ fetchFunctions: [getAccommodations], cleanUpFunctions: [clearAccommodations], params })

    const removeItem = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteAccommodation(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: accommodations.length < 2,
                },
                word: 'delete accommodation',
            }),
        )
    }

    const renderSection = () => {
        switch (active) {
            case 'Dashboard':
                return <AccomodationDashboard />
            case 'Bed Management':
                return <BedManagement />
            case 'Check-In':
                return <CheckIn />
            case 'Check-Out':
                return <CheckOut />
            case 'Guests':
                return <Guests />
            case 'Bed History':
                return <BedHistory />
            default:
                return <AccomodationDashboard />
        }
    }

    return (
        <>
            <NavBar />
            <PageWrapper noFooter>
                <Flex between center mb='16' >
                    <MainHeadline>Accommodation</MainHeadline>
                    <Button orange onClick={() => setModal(true)}>
                        Add Camp
                    </Button>
                </Flex>
                <Flex mt='16' mb='16' gap='0.5rem ' >
                    <TabsContainer>
                        <Tabs active={active === 'Dashboard'} onClick={() => setActive('Dashboard')} >Dashboard</Tabs>
                        <Tabs active={active === 'Bed Management'} onClick={() => setActive('Bed Management')} >Bed Management</Tabs>
                        <Tabs active={active === 'Check-In'} onClick={() => setActive('Check-In')} >Check-In</Tabs>
                        <Tabs active={active === 'Check-Out'} onClick={() => setActive('Check-Out')} >Check-Out</Tabs>
                        {/* <Tabs active={active === 'Housekeeping'} onClick={() => setActive('Housekeeping')} >Housekeeping</Tabs> */}
                        <Tabs active={active === 'Guests'} onClick={() => setActive('Guests')} >Guests</Tabs>
                        <Tabs active={active === 'Bed History'} onClick={() => setActive('Bed History')} >Bed History</Tabs>
                    </TabsContainer>

                </Flex>
                {renderSection()}
                {modal && <AddAccommodationModal closeModal={() => setModal(false)} />}
            </PageWrapper>
        </>
    )
}
